import Loading from "components/ui/Loading";
import { getDashboard, getUsersProfile } from "store/api/apiSlice";
import LineItems from "./LineItems";

const EwaEnabledInfo = () => {
  const { data: dashboard, isLoading: isLoadingDashboard } = getDashboard();
  const { data: userProfile, isLoading: isLoadingUserProfile } =
    getUsersProfile();

  const isLoading = isLoadingDashboard || isLoadingUserProfile;

  if (isLoading) return <Loading />;

  return <LineItems dashboard={dashboard} userProfile={userProfile} />;
};

export default EwaEnabledInfo;
